<template>
  <div
    id="authors"
  >
    <h2>
      Featured Authors
    </h2>

    <author-nav />

    <pagination
      :resourceUrl="resourceUrl"
      orderBy="created_at"
      orderType="DESC"
      ref="pagination"
      attrIncludes
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <span
          class="list-group-item list-group-item-action"
        >
          {{ item.name || item.username }}

          <button
            class="btn btn-danger btn-sm float-right ml-2"
            :data-user-id="item.id"
            @click="disfeature"
          >
            Remove
          </button>

          <router-link
            :to="{
              name: 'author',
              params: {
                authorId: item.id
              }
            }"
            class="btn btn-primary btn-sm float-right"
          >
            View
          </router-link>
        </span>
      </template>
    </pagination>
  </div>
</template>
<script>
import AuthorNav from '@/components/AuthorNav'

import Pagination from 'sai-vue-kaminari'

export default {
  components: {
    'author-nav': AuthorNav,
    pagination: Pagination
  },

  computed: {
    resourceUrl () {
      return this.apiUrl('/featured_authors', true)
    }
  },

  methods: {
    disfeature () {
      if (confirm('This will remove the author from the featured set. Are you sure you want to continue?')) {

      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FeaturedAuthors.vue